import type SchoolSubscription from 'teacher-ui-client/models/school-subscription'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

/**
 * filters school subscriptions by subscription type then returns the school
 * subscription with the least oldest date.
 */
export function lastExpiringOrExpiredSchoolSub(
  schoolSubscriptions: SchoolSubscription[],
  subscriptionType: SubscriptionType,
): SchoolSubscription | undefined {
  return schoolSubscriptions
    .filter((s) => s.subscriptionType === subscriptionType)
    .sort((a: SchoolSubscription, b: SchoolSubscription) => b.endDate.getTime() - a.endDate.getTime())[0]
}
